import get from 'lodash-es/get';
import defaultTo from 'lodash-es/defaultTo';
export default class Utils {
  /**
   * 根据 object对象的path路径获取值
   */
  static get(obj, path, defaultValue) {
    return defaultTo(get(obj, path), defaultValue);
  }
}
